// ThemeContainer.tsx
type ThemeContainerProps = {
  children: React.ReactNode;
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | 'full';
  className?: string;
  noPadding?: boolean;
};

const maxWidthClasses = {
  sm: 'max-w-3xl',
  md: 'max-w-5xl',
  lg: 'max-w-7xl',
  xl: 'max-w-screen-2xl',
  full: 'max-w-full'
};

export const ThemeContainer: React.FC<ThemeContainerProps> = ({ 
  children, 
  maxWidth = 'md',
  className = '',
  noPadding = false
}) => {
  return (
    <div className={`${maxWidthClasses[maxWidth]} mx-auto ${!noPadding && 'px-4 sm:px-6 lg:px-8'} py-8 space-y-8 ${className}`}>
      {children}
    </div>
  );
};